import React from "react";
import { observer } from "mobx-react";
import { WeaInput } from "ecCom";

@observer
export default class InputItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  onBlur = value => {
    const { itemKey, onBlur } = this.props;
    if (typeof onBlur === "function") {
      onBlur(itemKey, value);
    }
  };
  onEnterSearch = value => {
    const { itemKey, onEnterSearch } = this.props;
    if (typeof onEnterSearch === "function") {
      onEnterSearch(itemKey, value);
    }
  };
  render() {
    const { bindObj, c, type } = this.props;
    return (
      <WeaInput
        {...c}
        {...bindObj.bind()}
        ecId={`${this.props.ecId}_WeaInput@bhq4j0`}
        value={bindObj.value}
        type={type === "password" ? "password" : "nromal"}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onEnterSearch={this.onEnterSearch}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/InputItem.js